import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';

import { Icon, IconCollapse, IconExpand } from '@flixbus/honeycomb-icons-react';
import { Button, Heading } from '@flixbus/honeycomb-react';

import { rideListStore } from 'pages/RideListPage/RideListStore';

import FiltersChip from './FiltersChip';
import DaterangeFilterRides from './Inputs/DaterangeFilterRides';
import LineNumbers from './Inputs/LineNumbers';
import LocationsSearch from './Inputs/Locations';
import RunNames from './Inputs/RunNames';
import TimeForDaterange from './Inputs/Time';
import TripNumbers from './Inputs/TripNumbers';
import { rideFilterStore } from './RideFilterStore';

import styles from './styles.module.css';

const RideFiltersComponent = observer(() => {
	const { resetFilters, resetEnabled, isRideIdApplied } = rideFilterStore;
	const { isDeadheadsTabActive } = rideListStore;

	const [isShown, setIsShown] = useState(true);

	useEffect(() => {
		if (!resetEnabled) {
			setIsShown(true);
		}
	}, [resetEnabled]);

	const toggleCollapsed = () => {
		setIsShown(!isShown);
	};

	const isFiltersShown = isShown || !resetEnabled;
	return (
		<div className={`${styles.filters} ${isRideIdApplied ? styles.disabled : ''}`}>
			<div className={`${styles.row} ${styles.between}`}>
				<div className={styles.row}>
					<Heading size={4}>Filters</Heading>
					{resetEnabled && (
						<Icon
							onClick={toggleCollapsed}
							className={styles.hover}
							InlineIcon={isShown ? IconCollapse : IconExpand}
						/>
					)}
				</div>
				{resetEnabled && (
					<div className={styles.reset} onClick={resetFilters}>
						Reset Filters
					</div>
				)}
			</div>
			<FiltersChip />

			{isFiltersShown && (
				<div className={styles.form}>
					<div
						className={classNames([
							styles.filtersFlex,
							styles.flexTop,
							isDeadheadsTabActive && styles.disabled,
						])}
					>
						<LineNumbers />
						<TripNumbers />
						<RunNames />
					</div>

					<div className={styles.filtersFlex}>
						<LocationsSearch label="Departure location" />

						<div className={`${styles.filtersFlex} ${styles.time}`}>
							<DaterangeFilterRides />
							<TimeForDaterange extraClasses={styles.hours} />
						</div>

						<LocationsSearch label="Arrival location" isArrival={true} />

						<Button
							// disabled={appplyDisabled}
							id="submit"
							appearance="primary"
							extraClasses={styles.submit}
							type="submit"
						>
							Apply
						</Button>
					</div>
				</div>
			)}
		</div>
	);
});

export default RideFiltersComponent;
